import styled from 'styled-components/native';
import Ionicons from 'react-native-vector-icons/Ionicons';
import Feather from 'react-native-vector-icons/Feather';
import {RFPercentage, RFValue} from 'react-native-responsive-fontsize';
import {
  getBottomSpace,
  getStatusBarHeight,
} from 'react-native-iphone-screen-helper';
import MapView from 'react-native-maps';
import FastImage from '../../components/Interface/Images/FastImageWithFallback';
import {Platform} from 'react-native';

export const Container = styled.View`
  flex: 1;
`;

export const Content = styled.View`
  flex: 1;
  padding: 0 24px;
  margin-top: -${RFValue(30)}px;
`;

export const StationHeader = styled(MapView)`
  background: ${({theme}) => theme.colors.green_light};
  height: ${RFPercentage(30)}px;
`;

export const GoBackButton = styled.TouchableOpacity`
  margin: 0 15px;
  margin-top: ${Platform.OS === 'android'
    ? RFValue(20)
    : getStatusBarHeight()}px;
  z-index: 2;
  position: absolute;
`;
export const GoBackButtonIcon = styled(Feather)`
  color: ${({theme}) => theme.colors.text_dark};

  font-size: ${RFValue(24)}px;
`;

export const StationInfos = styled.View``;

export const StationDescription = styled.View`
  align-items: center;
  justify-content: center;
`;

export const StationFlag = styled(FastImage)`
  height: ${RFValue(50)}px;
  width: ${RFValue(50)}px;
  border: 2px solid ${({theme}) => theme.colors.image_border};
  border-radius: ${RFValue(12)}px;
`;

export const StationName = styled.View`
  align-items: center;
  justify-content: center;
  margin-top: ${RFValue(6)}px;
`;

export const Title = styled.Text`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.text_dark};
  font-family: ${({theme}) => theme.fonts.semibold};
  text-align: center;
`;

export const Subtitle = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text};
  font-family: ${({theme}) => theme.fonts.regular};
  text-align: center;
`;

export const MarkerView = styled(FastImage)`
  width: ${RFValue(40)}px;
  height: ${RFValue(40)}px;
  border: 2px solid ${({theme}) => theme.colors.image_border};
  border-radius: ${RFValue(10)}px;
`;

export const LocalizationList = styled.View`
  margin-top: ${RFValue(12)}px;
`;

export const Localization = styled.View`
  margin-bottom: ${RFValue(12)}px;
`;

export const Label = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text};
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const Local = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text_dark};
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const Footer = styled.View`
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding: 0 24px;
  padding-bottom: ${getBottomSpace() ? getBottomSpace() : RFValue(20)}px;
`;

export const OpenInMapContainer = styled.View`
  flex-direction: row;
`;

export const OpenInMapButtonOne = styled.TouchableOpacity`
  flex-direction: row;
  border-style: solid;
  border-color: ${({theme}) => theme.colors.blue};
  border-bottom-width: 2px;
`;

export const OpenInMapButtonOneText = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.blue};
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const OpenInMapButtonTwo = styled.TouchableOpacity`
  flex-direction: row;
  background: ${({theme}) => theme.colors.primary};
  height: ${RFValue(40)}px;
  padding: 0 ${RFValue(16)}px;
  align-items: center;
  border-radius: ${RFValue(22)}px;
`;

export const OpenInMapButtonTwoIcon = styled(Ionicons)`
  font-size: ${RFValue(18)}px;
  color: ${({theme}) => theme.colors.shape};
`;

export const OpenInMapButtonTwoText = styled.Text`
  margin-left: ${RFValue(8)}px;
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.shape};
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const MapIconButton = styled.TouchableOpacity`
  margin-right: ${RFValue(12)}px;
  width: ${RFValue(40)}px;
`;

export const OpenMapIcons = styled.View`
  flex-direction: row;
  align-items: flex-start;
`;

export const MapIcon = styled.Image`
  width: ${RFValue(41)}px;
  border-radius: 30px;
  height: ${RFValue(41)}px;
`;

export const OpenMapsTitle = styled.Text`
  color: ${({theme}) => theme.colors.black};
  font-size: ${RFValue(12)}px;
  margin-bottom: ${RFValue(8)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const OpenMapsContainer = styled.View``;

export const MapTitle = styled.Text`
  font-size: ${RFValue(9)}px;
  text-align: center;
  margin-top: 6px;
  line-height: ${RFValue(10)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.medium};
`;
